import { MediaType } from '../constants/MediaType';
const allowedExtForMusic = ['wav', 'mp3', 'flac', 'm4a', 'wma', 'aac'];
const allowedExtForVideo = ['avi', 'mpeg', 'mpg', 'mpe', 'mp4', 'mkv', 'webm', 'mov', 'ogv', 'vob', 'm4v', '3gp', 'divx', 'xvid', 'mxf', 'wmv', 'm1v'];
const allowedExtForFonts = ['ttf', 'otf', 'woff', 'woff2'];
const allowedExtForDocs = ['pdf', 'odp', 'odt', 'epub', 'doc', 'xls', 'ppt', 'docx', 'xlsx', 'pptx', 'dot', 'dotx', 'xlt', 'xltx', 'xlw', 'pot', 'potx', 'pps', 'ppsx', 'sldx'];
const allowedExtForPictures = ['gif', 'jpeg', 'jpg', 'png'];
const allowedExtForVectorArt = ['svg'];
const allowedExtForSWF = ['swf'];
const allowedExtForZip = ['zip'];
const allAllowedExtensions = [].concat(allowedExtForMusic, allowedExtForVideo, allowedExtForFonts, allowedExtForDocs, allowedExtForPictures, allowedExtForVectorArt, allowedExtForSWF, allowedExtForZip);
const isAcceptableExtensionFor = mediaTypeExtensions => extension => mediaTypeExtensions.indexOf(extension) !== -1;
export const isAcceptableExtension = isAcceptableExtensionFor(allAllowedExtensions);
export const isAcceptableMusicExtension = isAcceptableExtensionFor(allowedExtForMusic);
export const isAcceptableVideoExtension = isAcceptableExtensionFor(allowedExtForVideo);
export const isAcceptableZipExtension = isAcceptableExtensionFor(allowedExtForZip);
export const isAcceptableSWFExtension = isAcceptableExtensionFor(allowedExtForSWF);
export const isAcceptableVectorArtExtension = isAcceptableExtensionFor(allowedExtForVectorArt);
export const isAcceptablePictureExtension = isAcceptableExtensionFor(allowedExtForPictures);
export const getMediaTypeByExtension = function (extension) {
  if (extension === void 0) {
    extension = '';
  }
  extension = extension.toLowerCase();
  if (isAcceptableMusicExtension(extension)) {
    return MediaType.Music;
  } else if (isAcceptableVideoExtension(extension)) {
    return MediaType.Video;
  } else if (isAcceptablePictureExtension(extension)) {
    return MediaType.Picture;
  } else if (isAcceptableZipExtension(extension)) {
    return MediaType.Archive;
  } else if (isAcceptableSWFExtension(extension)) {
    return MediaType.SWF;
  } else if (isAcceptableVectorArtExtension(extension)) {
    return MediaType.Shape;
  }
  return MediaType.Document;
};
export const getFileExtension = item => item.name.indexOf('.') === -1 ? '' : item.name.toLowerCase().split('.').pop();